import { useEffect, useMemo, useState } from "react";
import { Col } from "reactstrap";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { APISD } from "../../../../../../config/apisd";
import ModalFormMateri from "../modal/ModalMateri";

export default function MateriTab({
  selectedMatpel,
  selectedAcademicYearId,
  selectedSemesterId,
  getToken,
  getUserId,
  getBranchId,
  getSchoolId,
  nameCollator,
  ToastSuccess,
  ToastError,
}) {
  const [materiData, setMateriData] = useState([]);
  const [searchMateri, setSearchMateri] = useState("");
  const [showModalMateri, setShowModalMateri] = useState(false);
  const [editMateriId, setEditMateriId] = useState(null);
  const [isFetchingMateri, setIsFetchingMateri] = useState(false);
  const [isSubmittingMateri, setIsSubmittingMateri] = useState(false);
  const [deletingMateriId, setDeletingMateriId] = useState(null);

  const [cpDataByMatpel, setCpDataByMatpel] = useState({});
  const [tpDataByCp, setTpDataByCp] = useState({});
  const [isFetchingTp, setIsFetchingTp] = useState(false);

  const [formMateri, setFormMateri] = useState({
    title: "",
    description: "",
    discuss: true,
    notofication: false,
    file_material: null,
    ysb_kelas_id: [],
    ysb_matpel_cp_id: "",
    ysb_matpel_tp_id: "",
  });

  const getArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data)) return responseData.data.data;
    if (Array.isArray(responseData?.data)) return responseData.data;
    if (Array.isArray(responseData?.result)) return responseData.result;
    if (Array.isArray(responseData)) return responseData;
    return [];
  };

  const groupCpByMatpel = (rows = []) => {
    return rows.reduce((acc, item) => {
      const matpelId =
        item?.ysb_matpel_id ||
        item?.matpel_id ||
        item?.id_matpel ||
        "tanpa_matpel";

      if (!acc[matpelId]) acc[matpelId] = [];

      acc[matpelId].push({
        id: item?.id,
        ysb_fase_id: item?.ysb_fase_id || "",
        ysb_academic_year_id: item?.ysb_academic_year_id || "",
        ysb_semester_id: item?.ysb_semester_id || "",
        ysb_branch_id: item?.ysb_branch_id || "",
        ysb_school_id: item?.ysb_school_id || "",
        ysb_grade_level_id: item?.ysb_grade_level_id || "",
        ysb_kelas_id: item?.ysb_kelas_id || "",
        ysb_matpel_id: item?.ysb_matpel_id || matpelId,
        nama_cp: item?.name_cp || item?.nama_cp || "",
        topik: item?.name_topic || item?.topik || "",
        keterangan: item?.description || item?.keterangan || "",
        raw: item,
      });

      return acc;
    }, {});
  };

  const groupTpByCp = (rows = []) => {
    return rows.reduce((acc, item) => {
      const cpId =
        item?.ysb_matpel_cp_id ||
        item?.matpel_cp_id ||
        item?.cp_id ||
        "tanpa_cp";

      if (!acc[cpId]) acc[cpId] = [];

      acc[cpId].push({
        id: item?.id,
        ysb_matpel_cp_id: item?.ysb_matpel_cp_id || cpId,
        tp: item?.name_tp || item?.tp || "",
        keterangan: item?.name_information || item?.keterangan || "",
        raw: item,
      });

      return acc;
    }, {});
  };


  const isSameSelectedCpContext = (item) => {
    const selectedMatpelId =
      selectedMatpel?.ysb_matpel_id || selectedMatpel?.id || "";

    const selectedGradeLevelId = selectedMatpel?.ysb_grade_level_id || "";

    const selectedKelasIds = Array.isArray(selectedMatpel?.selected_kelas_ids)
      ? selectedMatpel.selected_kelas_ids.map(String)
      : (selectedMatpel?.kelas_list || [])
          .map((kelas) => kelas?.ysb_kelas_id)
          .filter(Boolean)
          .map(String);

    const itemMatpelId =
      item?.ysb_matpel_id ||
      item?.matpel_id ||
      item?.id_matpel ||
      item?.raw?.ysb_matpel_id ||
      "";

    const itemGradeLevelId =
      item?.ysb_grade_level_id ||
      item?.grade_level_id ||
      item?.raw?.ysb_grade_level_id ||
      "";

    const itemKelasId =
      item?.ysb_kelas_id ||
      item?.kelas_id ||
      item?.raw?.ysb_kelas_id ||
      "";

    const itemAcademicYearId =
      item?.ysb_academic_year_id ||
      item?.academic_year_id ||
      item?.raw?.ysb_academic_year_id ||
      "";

    const itemSemesterId =
      item?.ysb_semester_id ||
      item?.semester_id ||
      item?.raw?.ysb_semester_id ||
      "";

    const sameMatpel =
      String(itemMatpelId) === String(selectedMatpelId);

    const sameGrade =
      !selectedGradeLevelId ||
      !itemGradeLevelId ||
      String(itemGradeLevelId) === String(selectedGradeLevelId);

    const sameKelas =
      !itemKelasId ||
      selectedKelasIds.length === 0 ||
      selectedKelasIds.includes(String(itemKelasId));

    const sameAcademicYear =
      !itemAcademicYearId ||
      !selectedAcademicYearId ||
      String(itemAcademicYearId) === String(selectedAcademicYearId);

    const sameSemester =
      !itemSemesterId ||
      !selectedSemesterId ||
      String(itemSemesterId) === String(selectedSemesterId);

    return sameMatpel && sameGrade && sameKelas && sameAcademicYear && sameSemester;
  };

  const normalizeMateriRows = (rows = []) => {
  return rows
    .filter((item) => isSameSelectedCpContext(item))
    .map((item) => ({
      id: item?.id,
      ysb_kelas_id: item?.ysb_kelas_id || "",
      ysb_grade_level_id: item?.ysb_grade_level_id || "",
      ysb_matpel_id: item?.ysb_matpel_id || "",
      ysb_matpel_cp_id: item?.ysb_matpel_cp_id || "",
      ysb_matpel_tp_id: item?.ysb_matpel_tp_id || "",
      title: item?.title || "",
      discuss: item?.discuss ?? true,
      notofication: item?.notofication ?? false,
      description: item?.description || "",
      file_material: item?.file_material || "",
      date_create_exam: item?.date_create_exam || item?.created_at || "",
      read_total:
        item?.read_total ||
        item?.total_read ||
        item?.total_reader ||
        item?.read_count ||
        0,
      raw: item,
    }));
};

  const getCpData = async () => {
    try {
      const token = getToken();

      const response = await APISD.get("/api/matpels-cp", {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        params: {
          page: 1,
          limit: 1000,
          ascending: 0,
          search: "",
          branch: "",
          level: localStorage.getItem("level") || "developer",
        },
      });

      setCpDataByMatpel(groupCpByMatpel(getArrayFromResponse(response?.data)));
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal mengambil data CP",
      });
    }
  };

  const getTpData = async () => {
    setIsFetchingTp(true);

    try {
      const token = getToken();

      const response = await APISD.get("/api/matpels-tp", {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        params: {
          page: 1,
          limit: 1000,
          ascending: 0,
          search: "",
          branch: "",
          level: localStorage.getItem("level") || "developer",
        },
      });

      setTpDataByCp(groupTpByCp(getArrayFromResponse(response?.data)));
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal mengambil data TP",
      });
    } finally {
      setIsFetchingTp(false);
    }
  };

  const getMateriData = async () => {
    if (!selectedMatpel?.id) return;

    setIsFetchingMateri(true);

    try {
      const token = getToken();

      const response = await APISD.get("/api/matpels-material", {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
        params: {
          page: 1,
          limit: 1000,
          ascending: 0,
          search: "",
          branch: "",
          level: localStorage.getItem("level") || "developer",
        },
      });

      setMateriData(normalizeMateriRows(getArrayFromResponse(response?.data)));
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal mengambil data materi",
      });
      setMateriData([]);
    } finally {
      setIsFetchingMateri(false);
    }
  };

  useEffect(() => {
  if (selectedMatpel?.id) {
    getCpData();
    getTpData();
    getMateriData();
    resetFormMateri();
    setSearchMateri("");
  }
}, [
  selectedMatpel?.id,
  selectedMatpel?.ysb_grade_level_id,
  selectedAcademicYearId,
  selectedSemesterId,
]);

  const currentCpData = useMemo(() => {
  if (!selectedMatpel?.id) return [];

  const matpelId = selectedMatpel?.ysb_matpel_id || selectedMatpel?.id;
  const rows = cpDataByMatpel[matpelId] || [];

  return rows.filter(isSameSelectedCpContext);
}, [
  cpDataByMatpel,
  selectedMatpel,
  selectedAcademicYearId,
  selectedSemesterId,
]);

  const filteredMateriData = useMemo(() => {
    const q = (searchMateri || "").trim().toLowerCase();

    const base = !q
      ? materiData || []
      : (materiData || []).filter((item) => {
          const title = (item?.title || "").toString().toLowerCase();
          const description = (item?.description || "").toString().toLowerCase();

          return title.includes(q) || description.includes(q);
        });

    return [...base].sort((a, b) =>
      nameCollator.compare(
        (a?.title || "").toString().trim(),
        (b?.title || "").toString().trim()
      )
    );
  }, [materiData, searchMateri, nameCollator]);

  const resetFormMateri = () => {
    setFormMateri({
      title: "",
      description: "",
      discuss: true,
      notofication: false,
      file_material: null,
      ysb_kelas_id: [],
      ysb_matpel_cp_id: "",
      ysb_matpel_tp_id: "",
    });

    setEditMateriId(null);
  };

  const handleChangeFormMateri = async (e) => {
    const { name, value, type, checked, files } = e.target;

    setFormMateri((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : type === "file"
          ? files?.[0] || null
          : value,
      ...(name === "ysb_matpel_cp_id"
        ? {
            ysb_matpel_tp_id: "",
          }
        : {}),
    }));

    if (name === "ysb_matpel_cp_id" && value) {
      await getTpData();
    }
  };

  const handleChangeKelasMateri = (kelasId) => {
    setFormMateri((prev) => {
      const currentKelas = Array.isArray(prev.ysb_kelas_id)
        ? prev.ysb_kelas_id
        : [];

      const isChecked = currentKelas.includes(kelasId);

      return {
        ...prev,
        ysb_kelas_id: isChecked
          ? currentKelas.filter((id) => id !== kelasId)
          : [...currentKelas, kelasId],
      };
    });
  };

  const handleSelectAllKelasMateri = () => {
    const allKelasIds = (selectedMatpel?.kelas_list || [])
      .map((kelas) => kelas?.ysb_kelas_id)
      .filter(Boolean);

    setFormMateri((prev) => {
      const currentKelas = Array.isArray(prev.ysb_kelas_id)
        ? prev.ysb_kelas_id
        : [];

      const isAllSelected =
        allKelasIds.length > 0 &&
        allKelasIds.every((kelasId) => currentKelas.includes(kelasId));

      return {
        ...prev,
        ysb_kelas_id: isAllSelected ? [] : allKelasIds,
      };
    });
  };

  const handleEditMateri = (item) => {
    setEditMateriId(item.id);

    setFormMateri({
      title: item?.title || "",
      description: item?.description || "",
      discuss: Boolean(item?.discuss),
      notofication: Boolean(item?.notofication),
      file_material: null,
      ysb_kelas_id: Array.isArray(item?.ysb_kelas_id)
        ? item.ysb_kelas_id
        : item?.ysb_kelas_id
        ? [item.ysb_kelas_id]
        : [],
      ysb_matpel_cp_id: item?.ysb_matpel_cp_id || "",
      ysb_matpel_tp_id: item?.ysb_matpel_tp_id || "",
    });

    setShowModalMateri(true);
  };

  const handleSubmitMateri = async (e) => {
    e.preventDefault();

    if (!selectedMatpel?.id) {
      ToastError.fire({
        icon: "error",
        title: "Mata pelajaran belum dipilih",
      });
      return;
    }

    if (!formMateri.title.trim()) {
      ToastError.fire({
        icon: "error",
        title: "Judul materi wajib diisi",
      });
      return;
    }

    const selectedKelasIds = Array.isArray(formMateri.ysb_kelas_id)
      ? formMateri.ysb_kelas_id
      : [];

    if (selectedKelasIds.length === 0) {
      ToastError.fire({
        icon: "error",
        title: "Pilih minimal 1 kelas",
      });
      return;
    }

    const token = getToken();
    const userId = getUserId();

    setIsSubmittingMateri(true);

    try {
      const payloadBase = {
        ysb_fase_id: "",
        ysb_academic_year_id: selectedAcademicYearId || "",
        ysb_semester_id: selectedSemesterId || "",
        ysb_branch_id: getBranchId(),
        ysb_school_id: getSchoolId(),
        ysb_grade_level_id: selectedMatpel?.ysb_grade_level_id || "",
        // ysb_matpel_id: selectedMatpel?.id || "",
        ysb_matpel_id: selectedMatpel?.ysb_matpel_id || selectedMatpel?.id || "",
        ysb_matpel_cp_id: formMateri.ysb_matpel_cp_id || "",
        ysb_matpel_tp_id: formMateri.ysb_matpel_tp_id || "",
        title: formMateri.title.trim(),
        discuss: formMateri.discuss ? true : false,
        notofication: formMateri.notofication ? true : false,
        description: formMateri.description || "",
        file_material: "",
        user_id: userId,
      };

      let response;

      if (editMateriId) {
        response = await APISD.put(
          `/api/matpels-material/${editMateriId}`,
          {
            ...payloadBase,
            ysb_kelas_id: selectedKelasIds[0] || "",
          },
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );
      } else {
        const requests = selectedKelasIds.map((kelasId) => {
          return APISD.post(
            "/api/matpels-material/store",
            {
              ...payloadBase,
              ysb_kelas_id: kelasId,
            },
            {
              headers: {
                Authorization: token,
                "Content-Type": "application/json",
              },
            }
          );
        });

        const responses = await Promise.all(requests);
        response = responses?.[0];
      }

      ToastSuccess.fire({
        icon: "success",
        title:
          response?.data?.message ||
          (editMateriId
            ? "Data materi berhasil diupdate"
            : "Data materi berhasil disimpan"),
      });

      resetFormMateri();
      setShowModalMateri(false);
      await getMateriData();
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          (editMateriId
            ? "Gagal update data materi"
            : "Gagal menyimpan data materi"),
      });
    } finally {
      setIsSubmittingMateri(false);
    }
  };

  const handleDeleteMateri = (item) => {
    Swal.fire({
      title: "Apakah Kamu Yakin?",
      text: "Data materi yang dihapus tidak bisa dikembalikan",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      const token = getToken();

      setDeletingMateriId(item.id);

      try {
        const response = await APISD.delete(
          `/api/matpels-material/${item.id}`,
          {
            headers: {
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        );

        ToastSuccess.fire({
          icon: "success",
          title: response?.data?.message || "Data materi berhasil dihapus",
        });

        await getMateriData();

        if (editMateriId === item.id) {
          resetFormMateri();
          setShowModalMateri(false);
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message || "Gagal menghapus data materi",
        });
      } finally {
        setDeletingMateriId(null);
      }
    });
  };

  return (
    <>
      <ModalFormMateri
        show={showModalMateri}
        onHide={() => {
          if (isSubmittingMateri) return;
          setShowModalMateri(false);
          resetFormMateri();
        }}
        editMateriId={editMateriId}
        formMateri={formMateri}
        handleChangeFormMateri={handleChangeFormMateri}
        handleSubmitMateri={handleSubmitMateri}
        isSubmittingMateri={isSubmittingMateri}
        selectedMatpel={selectedMatpel}
        currentCpData={currentCpData}
        tpDataByCp={tpDataByCp}
        isFetchingTp={isFetchingTp}
        handleChangeKelasMateri={handleChangeKelasMateri}
        handleSelectAllKelasMateri={handleSelectAllKelasMateri}
      />

      <div className="d-flex mt-4 mb-4">
        <div className="at-search">
          <input
            className="at-input"
            placeholder="Cari judul atau deskripsi materi"
            value={searchMateri}
            onChange={(e) => setSearchMateri(e.target.value)}
          />
        </div>

        <div className="ml-auto">
          <button
            type="button"
            onClick={() => {
              resetFormMateri();
              setShowModalMateri(true);
            }}
            className="btn btn-create mr-2"
            style={{
              borderRadius: 12,
              padding: "8px 14px",
              boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
              fontWeight: 600,
            }}
          >
            <FontAwesomeIcon icon={faPlus} /> Buat Materi
          </button>
        </div>
      </div>

      <Col xl="12" sm="12">
        <div className="mt-3 body-table">
          {/* <table className="table dt-responsive nowrap w-100"> */}
           <table className="table table-hover table-border-style" id="basic-datatable" >
            <thead>
              <tr>
                <th style={{ width: "130px"}}>
                  Telah Diumumkan
                </th>
                <th style={{width: "130px"}}>Tanggal Dibuat</th>
                <th style={{ textAlign: "center"}}>Judul</th>
                <th style={{ textAlign: "center"}}>Deskripsi</th>
                <th style={{ textAlign: "center"}}>Dibaca</th>
                <th style={{ width: "180px", textAlign: "center"}}>Aksi</th>
              </tr>
            </thead>

            <tbody>
              {isFetchingMateri ? (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center"
                    style={{ padding: "20px" }}
                  >
                    Mengambil data materi...
                  </td>
                </tr>
              ) : filteredMateriData.length > 0 ? (
                filteredMateriData.map((row, index) => (
                  <tr key={row?.id || index}>
                    <td style={{ textAlign: "center", lineHeight: "2" }}>
                      <span
                        style={{
                          display: "inline-flex",
                          padding: "4px 10px",
                          borderRadius: 999,
                          background: row?.notofication ? "#dcfce7" : "#fee2e2",
                          color: row?.notofication ? "#15803d" : "#b91c1c",
                          fontSize: 12,
                          fontWeight: 700,
                        }}
                      >
                        {row?.notofication ? "Ya" : "Belum"}
                      </span>
                    </td>
                    <td style={{ lineHeight: "2", textAlign: "center" }}>
                      {row?.date_create_exam
                        ? new Date(row.date_create_exam).toLocaleDateString(
                          "id-ID",
                          {
                            day: "2-digit",
                            month: "long",
                            year: "numeric",
                          }
                        )
                      : "-"}
                    </td>
                    <td style={{ lineHeight: "2", fontWeight: 600 }}>
                      {row?.title || "-"}
                    </td>

                    <td style={{ lineHeight: "2" }}>
                      {row?.description || "-"}
                    </td>

                    <td style={{ lineHeight: "2", textAlign: "center" }}>
                      {row?.read_total || 0}
                    </td>
                    <td style={{ textAlign: "center", lineHeight: "2" }}>
                      <div
                        className="d-flex justify-content-center"
                        style={{ gap: 8, flexWrap: "wrap" }}
                      >
                        <button
                          type="button"
                          className="btn btn-sm btn-warning"
                          onClick={() => handleEditMateri(row)}
                          style={{
                            borderRadius: 8,
                            color: "#fff",
                            fontWeight: 600,
                          }}
                        >
                          <FontAwesomeIcon icon={faPenToSquare} />
                        </button>

                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDeleteMateri(row)}
                          disabled={deletingMateriId === row.id}
                          style={{
                            borderRadius: 8,
                            fontWeight: 600,
                          }}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center"
                    style={{ padding: "20px" }}
                  >
                    Data materi belum tersedia
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Col>
    </>
  );
}